import { Button, Modal, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { MdLibraryAdd } from "react-icons/md";
import styled from "styled-components";
import api from "../../services/api";
import {
  ActionsContainer,
  ModalBody,
  SearchContainer,
  StyledTable,
  TableContainer
} from "../style/assign-device-modal.styled";

import { makeToasterErrorHandler } from "../../common/http/makeToasterErrorHandler";
import { usePageToast } from "../../hooks/usePageToast";
import PageToaster from "../toaster/PageToaster";

interface AssignProductModalProps {
  open: boolean;
  onClose: () => void;
  onProductAssigned: () => void;
  deviceId?: number;
  workOrderId: string;
}

const TableHeader = styled.th``;

const AssignProductModal: React.FC<AssignProductModalProps> = ({
  open,
  onClose,
  onProductAssigned,
  deviceId,
  workOrderId
}) => {
  const [search, setSearch] = useState("");
  const [results, setResults] = useState<any[]>([]);

  const [quantidadesEscolhidas, setQuantidadesEscolhidas] = useState<number>(0);

  const containerId = "toaster-assign-product-modal";
  const { autoSuccess, autoError, autoInfo, autoWarn } = usePageToast(
    containerId,
    true
  );

  const handleHttpError = makeToasterErrorHandler(autoError);

  useEffect(() => {
    if (!open) return;
    (async () => {
      try {
        const { data } = await api.get("/products", {
          params: {
            page: 1,
            limit: 20,
            ...(search ? { search } : {})
          }
        });

        setResults(data.items ?? []);
      } catch (err) {
        console.error(err);
        setResults([]);
      }
    })();
  }, [open, search]);

  const clear = () => {
    setSearch("");
    setResults([]);
    setQuantidadesEscolhidas(0);
  };

  const handleAssign = async (
    product_id: number,
    quantidadesEscolhidas: number
  ) => {
    if (quantidadesEscolhidas <= 0) {
      autoError("Quantidade deve ser maior que zero.");
      return;
    }
    try {
      await api.post(
        `/work-order/${workOrderId}/device/${deviceId}/product/${product_id}?quantity=${quantidadesEscolhidas}`
      );
      autoSuccess("Serviço associado com sucesso!");

      setResults((prev) => prev.filter((s) => s.product_id !== product_id));
      onProductAssigned();
      clear(); // Limpa os campos após a associação
      onClose();
    } catch (e: any) {
      handleHttpError(e);
      console.error("Erro ao associar serviço:", e);
    }
  };

  return (
    <>
      <PageToaster containerId={containerId} />
      <Modal open={open} onClose={onClose}>
        <ModalBody>
          <h2>Associar Produtos</h2>

          <SearchContainer>
            <TextField
              label="Buscar por Nome"
              fullWidth
              size="small"
              margin="dense"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </SearchContainer>

          <TableContainer>
            <StyledTable>
              <thead>
                <tr>
                  <TableHeader>Nome</TableHeader>
                  <TableHeader>Quantidade</TableHeader>
                  <TableHeader>Valor unitário (R$)</TableHeader>
                  <TableHeader>Quantidade escolhida</TableHeader>
                  <TableHeader>Ação</TableHeader>
                </tr>
              </thead>
              <tbody>
                {results.map((product) => (
                  <tr key={product.product_id}>
                    <td>{product.product_name}</td>
                    <td>{product.product_quantity}</td>
                    <td>{parseFloat(product.product_unit_price).toFixed(2)}</td>
                    <td>
                      <input
                        type="number"
                        min="1"
                        style={{ width: "60px" }}
                        value={quantidadesEscolhidas}
                        onChange={(e) =>
                          setQuantidadesEscolhidas(parseInt(e.target.value, 10))
                        }
                      />
                    </td>
                    <td>
                      <MdLibraryAdd
                        color="#03F"
                        style={{ cursor: "pointer" }}
                        size={18}
                        onClick={() =>
                          handleAssign(
                            product.product_id,
                            quantidadesEscolhidas
                          )
                        }
                      />
                    </td>
                  </tr>
                ))}
                {results.length === 0 && (
                  <tr>
                    <td
                      colSpan={4}
                      style={{ textAlign: "center", padding: "16px" }}
                    >
                      Nenhum serviço encontrado.
                    </td>
                  </tr>
                )}
              </tbody>
            </StyledTable>
          </TableContainer>

          <ActionsContainer>
            <Button onClick={onClose} color="secondary">
              Fechar
            </Button>
          </ActionsContainer>
        </ModalBody>
      </Modal>
    </>
  );
};

export default AssignProductModal;
